import { render, staticRenderFns } from "./BroadcastMessages.vue?vue&type=template&id=3670e016"
import script from "./BroadcastMessages.vue?vue&type=script&lang=js"
export * from "./BroadcastMessages.vue?vue&type=script&lang=js"
import style0 from "./BroadcastMessages.vue?vue&type=style&index=0&id=3670e016&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VChip,VDataTable,VIcon,VList,VListItem,VListItemTitle,VMenu,VSpacer})
